import { Box, Paper, Stack, Typography } from '@mui/material';

/**
 * 공통 페이지 틀 (docs/V1_ADMIN_SCREEN_REVIEW.md §5-1, S1·S4)
 * 머리말 한 줄: 아이콘 · 제목 · 요약(칩 등) · 오른쪽 버튼. 본문은 Section 카드 단위.
 * Layout 안에서 쓴다. 새 화면·수정하는 화면부터 적용.
 */
export function Page({ icon, title, subtitle, meta, actions, maxWidth = 1200, children }) {
  return (
    <Box sx={{ maxWidth, mx: 'auto', p: { xs: 1, sm: 2 } }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ mb: 2 }}>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon}
            <Typography component="h1" sx={{ fontSize: 20, fontWeight: 700 }}>{title}</Typography>
          </Box>
          {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>}
        </Box>
        {(meta || actions) && (
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" gap={1}>
            {meta}
            {actions}
          </Stack>
        )}
      </Stack>
      {children}
    </Box>
  );
}

export function Section({ title, icon, description, actions, children, sx }) {
  return (
    <Paper sx={{ p: 2, mb: 2, borderRadius: 2, ...sx }}>
      {(title || actions) && (
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} sx={{ mb: description ? 0.5 : 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon}
            {title && <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{title}</Typography>}
          </Box>
          {actions}
        </Stack>
      )}
      {description && <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>{description}</Typography>}
      {children}
    </Paper>
  );
}

export default Page;
